import { useState } from "react";
import { useLoginMutation } from "../../store/api/authApi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { APP_CONSTANTS } from "../../constants";
import { useDispatch } from "react-redux";
import { setSession } from "../../store/features/authSlice";
import { showToast } from "../utils/toasts/SharedToast";

export const LoginForm = () => {

  const dispatch = useDispatch();
  const [credentials, setCredentials] = useState({
    login: "",
    password: "",
    centerId: null,
    stationId: null,
  });

  const [login, { isLoading }] = useLoginMutation();
  const navigate = useNavigate();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await login(credentials).unwrap();

      // Assuming response contains accessToken, refreshToken, and user
      const { accessToken, refreshToken } = response.tokens;
      const { user } = response.data;

      

      dispatch(setSession({
        user,

        accessToken,

        refreshToken,

        currentCenter: null,
        currentBox: null
      }))

 
      showToast({
        id:"successfull-login",
        message:'Login successfull'
            })
 
            console.log("navigation to ",APP_CONSTANTS.ROUTES.HOME )
      navigate(APP_CONSTANTS.ROUTES.HOME);
    } catch (error: any) {
      toast.error(error?.data?.message || "An error occurred during login.");
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Login</h2>
      <form
        className="space-y-10 max-w-[22rem] min-w-[10rem] justify-center items-center"
        onSubmit={handleSubmit}
      >
        <h5 className="text-xl font-medium text-gray-900 dark:text-white">
          Connectez-vous
        </h5>
        <div>
          <label
            htmlFor="login"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Login
          </label>
          <input
            type="text"
            name="login"
            id="login"
            value={credentials.login}
            onChange={handleInputChange}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
            placeholder="Nom d'utilisateur"
            required
          />
        </div>
        <div>
          <label
            htmlFor="password"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Mot de Passe
          </label>
          <input
            type="password"
            name="password"
            id="password"
            value={credentials.password}
            onChange={handleInputChange}
            placeholder="Mot de passe"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
            required
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          {isLoading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
};
